$(function() {

  'use strict';
  
  var _this,
      _window = $(window);

  /**
   * _cards.scss
   *//*
  $(function() {
    _window.on('load', function() {
      $('.c-article-card-link').matchHeight();
    });
  });*/

});
